import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable, of, throwError } from 'rxjs'
import { catchError, filter } from 'rxjs/operators'
import { AuthenticationService } from '../../access/shared/authentication/authentication.service'
import { ConfigService } from '../../config/config.service'
import { NotificationService } from './notification.service'

@Injectable({
  providedIn: 'root'
})
export class NotificationInterceptorService implements HttpInterceptor {

  constructor(
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private config: ConfigService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      filter(response => response instanceof HttpResponse),
      catchError((event, caught) => {
        if (event instanceof HttpErrorResponse) {
          let code = event.error.code != undefined ? event.error.code : event.status
          switch (code) {
            case 401: {
              if (this.router.url.includes('reset-password-confirm')) {
                return
              }
              this.notificationService.notif("Accès refusé", "error")
              this.authenticationService.logout()
              if (this.router.url.includes('login')) {
                this.router.navigate([this.router.url])
              } else {
                this.config.getConfig().subscribe(config => {
                  this.router.navigate([config.postLogin], { queryParams: { redirectURI: this.router.url } })
                })
              }
              break
            }
            case 404: {
              if (!(event.error instanceof ArrayBuffer)) {
                this.notificationService.notif(event.error.message, "error")
              }
              break
            }
            case 0: {
              this.notificationService.notif("Vous êtes en Mode Hors Ligne", "error")
              break
            }
            default: {
              let error = event.error
              if (event.error instanceof ArrayBuffer) {
                error = JSON.parse(new TextDecoder().decode(event.error as ArrayBuffer))
              }
              if (typeof error == 'string') {
                if (error.includes("Aucun utilisateur")) {
                  this.notificationService.notif(error, "error")
                  return throwError(event)
                }
                this.notificationService.notif("Erreur " + code + " : dysfonctionnement technique. Si le problème persiste, veuillez nous contacter par téléphone.", "error")
                return throwError(event)
              } else {
                if (error.message == "Site en maintenance") {
                  this.router.navigate(['/maintenance'])
                  return throwError(event)
                }
                else if (error.message == "Commande déjà transmise" || error.message == "Le délai est dépassé pour transmettre cette commande") {
                  this.router.navigate(['/escli/linge-hebergement']).then(() => {
                    this.notificationService.notif(event.error.message, "error")
                    return throwError(event)
                  })
                }
                if (!error.message) {
                  this.notificationService.notif("Erreur " + code + " : dysfonctionnement technique. Si le problème persiste, veuillez nous contacter par téléphone.", "error")
                  return throwError(event)
                }
                this.notificationService.notif(error.message, "error")
                return throwError(event)
              }
            }
          }
        } else if (event instanceof HttpResponse && event.body != null) {
          return throwError(event)
        }
        return of(event)
      })
    )
  }
}
